var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.636 18.3639C7.10845 19.8364 9.04594 20.7527 11.1183 20.9567C13.1906 21.1607 15.2696 20.6398 17.0009 19.4827C18.7322 18.3256 20.0087 16.604 20.6129 14.6112C21.217 12.6184 21.1115 10.4778 20.3142 8.55408C19.5169 6.63039 18.0772 5.0427 16.2404 4.06158C14.4037 3.08045 12.2835 2.7666 10.2413 3.17352C8.19909 3.58043 6.36116 4.68293 5.04073 6.29312C3.72031 7.90332 2.99909 9.92157 3 12.0039V13.9999",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 12L3 14L5 12M11 8V13H16",
    stroke: "#636980",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHistory);
export default __webpack_public_path__ + "static/media/history.6848e5336cde79cbfb4d453d95b9a3c1.svg";
export { ForwardRef as ReactComponent };